import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';

type Payload = {
  email: string;
  password: string;
  username: string;
};

export const authMigration = createApiSlice<unknown, Payload>({
  name: 'authMigration',
  *tryGenerator(_, { payload: { password, email, username } }) {
    try {
      yield call(amplifyClient, {
        method: 'put',
        url: getEndpointV2({ path: '/auth/user/:username/migration', urlParams: { username } }),
        data: {
          userEmail: email,
          userData: password,
        },
      });
    } catch (e) {
      console.log('Error in authMigration call', e);
    }

    return null;
  },
});
